import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import SdkDisclosureRow from './SdkDisclosureRow'

import Locale from './locale'
import Styles from './styles.scss'


export default function SdkDisclosureTable({ sdks }) {
  return (
    <table className={ Styles.root }>
      <thead className={ Styles.thead }>
        <tr>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.name }
            />
          </th>
          <th className={ Styles.th }>
            <FormattedMessage
              { ...Locale.description }
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {
          renderRows(sdks)
        }
      </tbody>
    </table>
  )
}

SdkDisclosureTable.propTypes = {
  sdks: PropTypes.arrayOf(
    PropTypes.shape(SdkDisclosureRow.propTypes)
  ),
}

function renderRows(sdks) {
  return sdks.map(({ name, use }) => (
    <SdkDisclosureRow
      key={ name }
      name={ name }
      use={ use }
    />
  ))
}
